import xhr from 'xhr';
import config from 'config/application';

export const TOKEN_PATH = 'user.authentication.token';

export class APIError extends Error {
  #message;
  #response;

  constructor(message, response) {
    super(message);
    this.name = this.constructor.name;
    this.#message = message;
    this.#response = response;
    Object.defineProperty(this, 'message', {
      get: () => this.toString()
    });
  }

  get response() {
    return this.#response;
  }
  get statusCode() {
    return this.#response?.statusCode;
  }
  get errorMessage() {
    return this.#response?.json?.errors ?? this.#response?.json?.error;
  }

  toString() {
    return this.#message ?? this.errorMessage ?? `HTTP ${this.statusCode}`;
  }
}

export class Rest {
  #store;
  constructor(store) {
    this.#store = store;
  }
  get store() {
    return this.#store;
  }
  get authToken() {
    return _.get(this.store.getState(), TOKEN_PATH);
  }
  get authHeaders() {
    return _.isEmpty(this.authToken) ? {} : {Authorization: 'Bearer ' + this.authToken};  }
  get dispatch() {
    return this.#store.dispatch;
  }
  get del() {
    return this.delete;
  }
  get authToken() {
    return this.store.getState()?.user?.authentication?.token;
  }

}

_.each(['get', 'post', 'patch', 'delete'], (method) => {
  Rest[method] = (options={}, callback) => {
    return xhr({...{method: method.toUpperCase()}, ...options}, callback);
  };

  Object.defineProperty(Rest.prototype, method, {
    value: function (path, body, {includeAuthHeader=true, headers={}, ...options}={}) {
      const url = config.apiHost + path;
      return new Promise((resolve, reject) => {
        try {
          Rest[method].call(Rest, {
            url,
            method: method.toUpperCase(),
            json: body,
            headers: {
              ...headers,
              ...(includeAuthHeader ? this.authHeaders : true),
            },
            ...options,
          },
          (err, response) => {
            this.dispatch({type: 'SET_NETWORK_STATUS', network_status: response.statusCode > 0});
            if (err || response.statusCode >= 400) {
              if (response.statusCode == 401) {
                this.dispatch({type: 'LOGOUT'});
              }
              reject(new APIError(err?.message, response));
              return;
            }

            resolve(response);
          });
        } catch(e) {
          reject(e);
        }
      });
    },
    enumerable: true,
    writable: false,
    configurable: false,
  });
});

export default Rest;
